define('services/ExtensionVoucherService',['require','lib/backbone/Backbone.Mixins.Transport.API'],function(require) {

  var APITransport = require('lib/backbone/Backbone.Mixins.Transport.API');

  return {

    acceptAgreement: function(orgId, attributes) {
      return APITransport.request('POST', '/extension-voucher/{0}/agreement'.format(orgId), attributes);
    },

    getExtensionVouchers: function(orgId, attributes) {
      return APITransport.request('GET', '/extension-voucher/{0}'.format(orgId), attributes, { ignoreHTTPErrors: true });
    },

    redeemExtensionVoucher: function(extensionId, attributes) {
      return APITransport.request('POST', '/extension-voucher/request/{0}'.format(extensionId), attributes);
    }

  };
});

